module.exports = __webpack_public_path__ + "img/update0-01.482a63e8.svg";